import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const services = [
  {
    icon: 'ri-building-2-line',
    title: 'Galpones Industriales',
    desc: 'Diseño y construcción de galpones metálicos de alta resistencia para uso industrial, agrícola y logístico en todo Chile.',
    img: 'https://public.readdy.ai/ai/img_res/edited_709c45eb2f511fccb8514bc1e88dda5f_49a5c4f4.jpg',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Locales Comerciales',
    desc: 'Construcción de locales comerciales modernos y funcionales, adaptados a las necesidades de cada negocio.',
    img: 'https://i.imgur.com/tl7d4Yb.jpg',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Obras Civiles',
    desc: 'Ejecución de obras civiles en general: fundaciones, estructuras de hormigón, pavimentación y más.',
    img: 'https://public.readdy.ai/ai/img_res/edited_93665d4c5098f15ab9c39263b76e7bda_41776496.jpg',
  },
];

const ServicesPreview = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section className="py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headerRef}
          className={`text-center mb-16 ${headerVisible ? 'reveal-visible' : ''} reveal`}
        >
          <span className="text-[#C88A2A] text-sm font-bold uppercase tracking-widest">Lo que hacemos</span>
          <h2 className="text-3xl md:text-4xl font-black text-[#0C1D2E] mt-2 mb-4">
            Nuestros Servicios Principales
          </h2>
          <p className="text-[#475569] text-base max-w-xl mx-auto">
            Soluciones constructivas integrales para empresas y particulares en todo Chile.
          </p>
          <Link
            to="/proyectos"
            className="inline-flex items-center gap-1 text-[#C88A2A] text-sm font-semibold mt-3 hover:gap-2 transition-all duration-200 whitespace-nowrap"
          >
            Ver obras realizadas <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div
          ref={gridRef}
          className={`grid grid-cols-1 md:grid-cols-3 gap-8 ${gridVisible ? 'reveal-visible' : ''} reveal`}
        >
          {services.map((service, i) => (
            <div
              key={service.title}
              className={`bg-white rounded-lg overflow-hidden group cursor-pointer hover:-translate-y-1 transition-transform duration-300 reveal ${gridVisible ? 'reveal-visible' : ''} reveal-delay-${(i + 1) * 100}`}
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0C1D2E]/60 to-transparent"></div>
                <div className="absolute bottom-5 left-5 w-12 h-12 flex items-center justify-center bg-[#1A3A5C] rounded-lg">
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
              </div>
              <div className="p-7">
                <h3 className="text-[#0C1D2E] font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-[#475569] text-sm leading-relaxed mb-4">{service.desc}</p>
                <Link
                  to="/servicios"
                  className="inline-flex items-center gap-1 text-[#C88A2A] text-sm font-semibold hover:gap-2 transition-all duration-200 whitespace-nowrap"
                >
                  Ver más <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div
          ref={ctaRef}
          className={`text-center mt-12 ${ctaVisible ? 'reveal-visible' : ''} reveal`}
        >
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 bg-[#1A3A5C] hover:bg-[#152e45] text-white font-bold px-8 py-3.5 rounded-md transition-colors duration-200 whitespace-nowrap"
          >
            Ver todos los servicios <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;